module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaKriminatlity@2x-5abebf07bc80a13693d4fedfd3a5a09c.png";